const SERVICE_WORKER_URL = '/service-worker.js';

export const registerServiceWorker = () => {
    if (
        process.env.NODE_ENV !== 'production' ||
        typeof window === 'undefined' ||
        !('serviceWorker' in navigator)
    ) {
        return;
    }

    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register(
                SERVICE_WORKER_URL,
                { scope: '/' }
            );
            await registration.update();

            registration.addEventListener('updatefound', () => {
                const worker = registration.installing;
                worker?.addEventListener('statechange', () => {
                    if (
                        worker.state === 'installed' &&
                        navigator.serviceWorker.controller
                    ) {
                        window.dispatchEvent(new Event('boozeon:update-available'));
                    }
                });
            });
        } catch (error) {
            console.warn('Offline support could not be enabled', error);
        }
    });
};

